/**
 * A colour token of styles/index.css as a value, for a library that takes colours instead of classes (antd).
 * Read at render, so the theme stays the one source; the variable exists once any class uses the token.
 */
export const colorToken = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(`--color-${name}`).trim();
